import { useAuth } from '@sine/auth-client';

import authService from './authentication/auth.service';
import { queryClient } from './query.client';
import { ROUTE_PATH } from './routing/routeConfig';
import rxEventHub, { RxEvent } from './services/events/rx';
import socketEventHub, { ReceiveSocketEvent } from './services/events/sockets';
import siteService from './services/site/site.service';

export function initialiseGlobalEventListeners() {
  rxEventHub.on(RxEvent.LOGOUT, () => {
    siteService.reset();
    queryClient.clear();
  });

  rxEventHub.on(RxEvent.SITE_DELETED, () => {
    queryClient.clear();
  });

  socketEventHub.on(ReceiveSocketEvent.USER_SOFT_DELETED, () => {
    rxEventHub.broadcast(RxEvent.USER_SOFT_DELETED, {});
  });

  socketEventHub.on(
    ReceiveSocketEvent.TEAM_DELETED,
    () => {
      const { isImpersonating } = useAuth();

      if (!isImpersonating) {
        rxEventHub.broadcast(RxEvent.LOGOUT, {});
        window.location.href = 'login';
      } else {
        setTimeout(function () {
          // if a team is deleted from the '/team/about' page
          // we should redirect users to the profile page
          if (window.location.pathname === '/team/about') {
            window.location.href = ROUTE_PATH.USER_SETTINGS;
          } else {
            window.location.href = 'activity';
            authService.handleSysAdminTokenExpired();
          }
        }, 500);
      }
    },
    false,
  );
}
